var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.6665H5C3.61667 1.6665 2.5 2.77484 2.5 4.1415V13.2332C2.5 14.5998 3.61667 15.7082 5 15.7082H5.63333C6.3 15.7082 6.93333 15.9665 7.4 16.4332L8.825 17.8415C9.475 18.4832 10.5333 18.4832 11.1833 17.8415L12.6083 16.4332C13.075 15.9665 13.7167 15.7082 14.375 15.7082H15C16.3833 15.7082 17.5 14.5998 17.5 13.2332V4.1415C17.5 2.77484 16.3833 1.6665 15 1.6665ZM10 4.7915C11.075 4.7915 11.9417 5.65817 11.9417 6.73317C11.9417 7.80817 11.075 8.67484 10 8.67484C8.925 8.67484 8.05833 7.79984 8.05833 6.73317C8.05833 5.65817 8.925 4.7915 10 4.7915ZM12.2333 12.5498H7.76667C7.09167 12.5498 6.7 11.7998 7.075 11.2415C7.64167 10.3998 8.74167 9.83317 10 9.83317C11.2583 9.83317 12.3583 10.3998 12.925 11.2415C13.3 11.7998 12.9 12.5498 12.2333 12.5498Z",
    fill: "#EBDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.476410518f6c524c25fabfe96dfddacf.svg";
export { ForwardRef as ReactComponent };